"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const customersListQuery_1 = __importDefault(require("./graphql/customersListQuery"));
const markCustomerAsReadMutation_1 = __importDefault(require("./graphql/markCustomerAsReadMutation"));
const exception_1 = require("@almservices-cl/exception");
const intakeQuery_1 = __importDefault(require("./graphql/intakeQuery"));
const customerQuery_1 = __importDefault(require("./graphql/customerQuery"));
const changeCoachingDayMutation_1 = __importDefault(require("./graphql/changeCoachingDayMutation"));
const DayOfWeekUtil_1 = __importDefault(require("../../../BusinessLogicLayer/DayOfWeekUtil"));
const subscriptionsQuery_1 = __importDefault(require("./graphql/subscriptionsQuery"));
const period_to_subscription_mapper_1 = require("@almservices-cl/period-to-subscription-mapper");
class CustomerList {
    constructor(client, logger, customerListAdapter) {
        this.getCustomers = async () => {
            const response = (await this.client.fetch("coachTrainees", customersListQuery_1.default, {}));
            return response.coachTrainees.map(this.customerListAdapter.adaptCustomerItem);
        };
        this.getCustomer = async (customerId) => {
            const response = (await this.client.fetch("coachTrainee", customerQuery_1.default, {
                id: customerId,
            }));
            return this.customerListAdapter.adaptCustomerItem(response.coachTrainee);
        };
        this.markCustomerAsRead = async (customerId) => {
            const response = (await this.client.fetch("markUserAsRead", markCustomerAsReadMutation_1.default, {
                user: parseInt(customerId),
            }));
            if (!response.markUserAsRead.success) {
                this.logger.log(response.markUserAsRead.messages.join(","));
                throw new exception_1.DomainException("Failed to mark user as read!");
            }
        };
        this.getLatestIntakeInfo = async (customer) => {
            const result = (await this.client.fetch("intake", intakeQuery_1.default, {
                subscriptionId: parseInt(customer.subscriptionPeriod.periodId),
            }));
            return this.customerListAdapter.adaptIntake(result.intake);
        };
        this.changeCoachingDay = async (customer, coachingDays) => {
            if (customer.subscriptionPeriod.periodType.numberOfCoachingDays !==
                coachingDays.length) {
                throw new exception_1.DomainException(`current member period supports ${customer.subscriptionPeriod.periodType.numberOfCoachingDays} coaching days, got ${coachingDays.length}`);
            }
            const response = (await this.client.fetch("changeCoachingDays", changeCoachingDayMutation_1.default, {
                subscriptionId: parseInt(customer.subscriptionPeriod.periodId),
                coachingDays: coachingDays.map((day) => DayOfWeekUtil_1.default.translateDayOfWeekToString(day).toUpperCase()),
            }));
            if (!response.changeCoachingDays.success) {
                this.logger.log(response.changeCoachingDays.messages.join(","));
                throw new exception_1.DomainException("Failed to change coaching day!");
            }
        };
        this.getCustomerPeriods = async (customerId) => {
            const response = (await this.client.fetch("coachTraineeSubscriptions", subscriptionsQuery_1.default, { id: parseInt(customerId) }));
            return {
                currentSubscriptionId: response.coachTrainee.currentPeriod.subscriptionId,
                periods: response.coachTrainee.periods,
            };
        };
        this.getCustomerSubscriptions = async (customerId) => {
            const { currentSubscriptionId, periods } = await this.getCustomerPeriods(customerId);
            return {
                currentSubscriptionId: currentSubscriptionId,
                subscriptions: (0, period_to_subscription_mapper_1.RawPeriodsToSubscriptionAdapter)(periods),
            };
        };
        this.client = client;
        this.logger = logger;
        this.customerListAdapter = customerListAdapter;
    }
}
exports.default = CustomerList;
//# sourceMappingURL=CustomerList.js.map